import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import * as _ from 'lodash';
import { debounceTime } from 'rxjs/operators';
import { FormFieldBaseComponent } from '../form-field-base/form-field-base.component';

@Component({
    selector: 'form-field-textarea',
    templateUrl: './form-field-textarea.component.html',
    styleUrls: ['./form-field-textarea.component.css'],
    imports: [MatFormField, MatLabel, MatInput, CdkTextareaAutosize, FormsModule, ReactiveFormsModule],
    inputs: FormFieldBaseComponent.baseInputs
})
export class FormFieldTextareaComponent extends FormFieldBaseComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {

    // build validators
    var validators = [];
    if (this.required) validators.push(Validators.required);
    if (this.pattern) validators.push(Validators.pattern(this.pattern));

    // create field control
    this.fieldCtrl = new FormControl(this.value, {
      validators: validators,
      updateOn: 'change'
    });

    // set disabled
    if (this.readonly)
      this.fieldCtrl.disable();

    // react to value change
    this.fieldCtrl.valueChanges.pipe(debounceTime(500))
      .forEach((value: any) => {

        // do not promote undefined
        if (_.isUndefined(value))
          return;

        // do nothing if invalid
        if (this.fieldCtrl.invalid)
          return;

        // set value
        this.value = value;

      });

    // register control
    this.register(this.fieldCtrl);

  }

  ngOnChanges() {

    if (this.fieldCtrl)
      this.fieldCtrl.setValue(this.value);

  }

}
